import { useCallback } from "react";
import { BlendCategory } from "domains/models/constants/blend";
import useRouter from "domains/navigation/hooks/useRouter";
import Button from "domains/ui/components/Button";

import { Grid, GridItem, HStack, Image, Text, VStack } from "@chakra-ui/react";

interface BlendCategoriesListProps {
  parentCategoryId?: string;
  categories: BlendCategory[];
}

export default function BlendCategoriesList({
  parentCategoryId,
  categories,
}: BlendCategoriesListProps) {
  const router = useRouter();

  const handleTagClick = useCallback(
    (categoryId: string) => {
      void router.push({
        pathname: router.pathname,
        query: {
          categoryId: parentCategoryId ?? categoryId,
          ...(parentCategoryId ? { subCategoryId: categoryId } : {}),
        },
      });
    },
    [router, parentCategoryId]
  );

  return (
    <VStack align="stretch" w="100%" spacing={2}>
      <Text color="textSecondary" textAlign="left" size="body.bold.md">
        Categories
      </Text>

      <Grid
        gap={2}
        templateColumns={[
          "repeat(1, 1fr)",
          "repeat(2, 1fr)",
          "repeat(2, 1fr)",
          "repeat(3, 1fr)",
          "repeat(4, 1fr)",
        ]}
      >
        {categories.map(({ label, tagId, thumbnail }) => (
          <GridItem key={tagId}>
            <Button
              onClick={() => handleTagClick(tagId)}
              variant="secondary"
              w="full"
              h="full"
              bgColor="backgroundSecondary.500"
              border="none"
              px={1}
            >
              <BlendCategoriesCard tag={label} thumbnailUrl={thumbnail} />
            </Button>
          </GridItem>
        ))}
      </Grid>
    </VStack>
  );
}

// ------------------------------------

interface BlendCategoriesCardProps {
  tag: string;
  thumbnailUrl: string;
}

function BlendCategoriesCard({ tag, thumbnailUrl }: BlendCategoriesCardProps) {
  return (
    <HStack w="full" py={1} borderRadius="xl">
      <Image
        w="70px"
        h="70px"
        borderRadius="lg"
        objectFit="cover"
        alt={tag + "-thumbnail"}
        src={thumbnailUrl}
      />
      <Text px={1} color="textSecondary" isTruncated size="body.md">
        {tag.replace("-", " ").replace("_", " ")}
      </Text>
    </HStack>
  );
}
